module.exports = __webpack_public_path__ + "static/img/autumn_banner.214b3157.jpg";